import styled, { keyframes } from 'styled-components';

import { ButtonSquare, Input } from '@xsolla/ui-core';

export const OptionsWrapper = styled.div`
  position: relative;
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const ListWrapper = styled.div`
  width: 100%;
  animation: 0.1s ${fadeIn} ease-out;
  position: absolute;
  z-index: 10;
  top: 10px;
`;

export const WrappedInput = styled(Input)<{ hovered: boolean }>`
  border: none;
  box-shadow: none;
`;

export const InputWrapper = styled.div`
  flex-grow: 1;
`;

export const SelectInputWrapper = styled.div<{ disabled: boolean }>`
  position: relative;
  display: flex;
  background-color: ${({ disabled, theme }) => (disabled ? theme.colors.overlay : 'white')};
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  border-radius: 6px;
  box-shadow: transparent 0 0 0 1px inset;
`;

export const FieldInputTitle = styled.div`
  color: ${(props) => props.theme.colors.muted};
`;

export const FieldInputType = styled.span`
  flex-basis: 340px;
`;

export const DropdownIconWrapper = styled.div`
  display: flex;
  margin-left: 4px;
  margin-right: 4px;
`;

export const SelectFieldWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-basis: 100%;
  gap: 6px;
  cursor: pointer;
  padding: 0 12px;
  font-family: 'Roboto', sans-serif;
  line-height: 22px;
  font-size: 14px;
  direction: ltr;
  color: ${(props) => props.theme.colors.text};
`;

export const SeparatingLine = styled.div`
  width: 1px;
  height: 44px;
  background-color: ${(props) => props.theme.colors.stroke};
`;

export const ExtraRightButton = styled(ButtonSquare)`
  margin-left: 8px;
`;
